import { graphql } from 'gql.tada';
import { useQuery } from '@apollo/client';
import type { ResultOf } from 'gql.tada';

const EnrollmentChecklistsQuery = graphql.persisted(
  "EnrollmentChecklists",
  graphql(`
    query EnrollmentChecklists($schoolId: ID!) {
      enrollmentChecklists(schoolId: $schoolId) {
        name
        kind
        version
        isDefault
        approveReturningAutomatically
        newChildrenOnFirstStep
        aidRequests
        enrollWhenComplete
        steps {
          key
          name
          type
          scope
          required
          content
        }
      }
    }
  `)
);

type EnrollmentChecklistsResult = NonNullable<ResultOf<typeof EnrollmentChecklistsQuery>>;
export type EnrollmentChecklistVersion = EnrollmentChecklistsResult['enrollmentChecklists'][number];
export type EnrollmentChecklistStep = EnrollmentChecklistVersion['steps'][number];

export { EnrollmentChecklistsQuery };

export function useEnrollmentChecklistsQuery(schoolId?: string) {
  return useQuery(EnrollmentChecklistsQuery, {
    variables: { schoolId: schoolId! },
    skip: !schoolId,
  });
}
